var MyHealthClinic = MyHealthClinic || {};
MyHealthClinic.Pages = MyHealthClinic.Pages || {};
MyHealthClinic.Pages.Home = MyHealthClinic.Pages.Home || {};

MyHealthClinic.Pages.Home.Index = function () {
    'use strict';

    var initialize = function () {

    };

    return {
        initialize: initialize
    };
}();

MyHealthClinic.Pages.Home.Index.initialize();


